import { createFileRoute } from '@tanstack/react-router';

import { Panel } from '@/view/pages/Panel';

export const Route = createFileRoute('/_protected/$programId/eprod/$scriptId/painel')({
  component: Panel,
});
